


import { Component, Vue } from 'vue-property-decorator';
import ConfContainer from '../../components/ConfContainer/index.vue';
import PageTransitionMode from '@/utils/mixins/pageTransitionMode';
import { namespace } from 'vuex-class';
import { Floor, Zone } from '../../utils/api';
import { RenderMode } from '../../components/ConfContainer/ConfContainer.models';
import { SelectType } from '../../components/SelectionPanel/SelectionPanel.models';
import { Route } from 'vue-router';

const groundFloorModule = namespace('groundFloor');
const configurationModule = namespace('configuration');

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    ConfContainer
  },
  mixins: [PageTransitionMode]
})
export default class GroundFloor extends Vue {
  @groundFloorModule.State private completedZoneIDs!: string[];

  @groundFloorModule.Getter private floor!: Floor;
  @groundFloorModule.Getter private activeZone!: Zone;
  @groundFloorModule.Getter private activeSubzone!: Zone;

  @groundFloorModule.Action private showLayout!: () => void;
  @groundFloorModule.Action private updateActiveZone!: (zoneID: string) => void;
  @groundFloorModule.Action private updateActiveSubzone!: (zoneID: string) => void;
  @groundFloorModule.Action private addCompletedZone!: (zoneID: string) => void;
  @configurationModule.Action private setVisitedZones!: (zoneID: string) => void;

  // to make ts enums work in vue template
  private SelectType: typeof SelectType = SelectType;
  private RenderMode: typeof RenderMode = RenderMode;

  public beforeRouteLeave(_to: Route, _from: Route, next: () => void) {
    if (this.activeZone) {
      this.addCompletedZone(this.activeZone.ID);
    }

    if (this.completedZoneIDs.length === this.floor.zones.length) {
      this.$store.dispatch('app/completeStep', this.$route.name || '');
    }

    next();
  }

  private changeZone(zoneID: string) {
    this.setVisitedZones(zoneID);
    this.updateActiveZone(zoneID);

    if (this.activeZone.zones && this.activeZone.zones.length > 0) {
      // if we do have subzones in the new zone, try to find one that has a selected module
      const zoneWithActiveModules = this.activeZone.zones.find(zone => zone.modules?.some(module => module.isSelected));
      // if none can be found, use the first one as a fallback
      const firstHighlightedSubzone = zoneWithActiveModules || this.activeZone.zones[0];
      // update the selection
      this.updateActiveSubzone(firstHighlightedSubzone.ID);
      this.setVisitedZones(firstHighlightedSubzone.ID);
    }
  }

  private changeSubzone(zoneID: string) {
    this.setVisitedZones(zoneID);
    this.updateActiveSubzone(zoneID);
  }
}
